import React from 'react';

export default function VoucherBookingForm() {
  return <div>This is a voucher booking and no further information is required.</div>;
}
